module.exports = __webpack_public_path__ + "static/media/dropdown.061693bb.svg";